import {dealData} from "./deal";
import axios from "axios";
import {getBackendURL, httpResponse, httpResponseError} from "../../fn";

/**************
 *
 * СОБЫТИЯ ВОЗНИКАЮЩИЕ НА СТОРОНЕ РОСРЕЕСТРА ПО СДЕЛКЕ
 *
 *************/


/**
 * Получаем данные по КУВД, если сделка была принята к рассмотрению в РР
 * @returns {null|{kuvdNumber: any, kuvdDate: any}}
 */
export const getKUVDParams = ( ) => {
  const result = dealData.rrEvents?.find((item)=>item.name === 'accepted');

  if(result)
    return {kuvdNumber: result.event.KUVDNumber, kuvdDate: result.event.KUVDDate}

  return null;
}

export const getCommentFromParent = () => {
  const comment = dealData.deal.comment;
  if(comment) {
    return comment;
  }
  return;
}

/**
 * Получить список событий Росреестра
 * @param dealId
 * @returns {Promise<unknown>}
 */
export const getRREvents = async (dealId) => {
  const result = await new Promise((resolve) => {
    axios.get(`${getBackendURL()}/deal/${dealId}/rrevents`, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  })

  if (result.ok)
    dealData.rrEvents = result.data;

  return result;
}